import ApiService from '@/common/api.service'

export default {
  getListFileClient (ankenId, reportType = null) {
    return new Promise((resolve, reject) => {
      const requestData = { ankenId }
      if (reportType !== null) {
        requestData.reportType = reportType
      }
      ApiService.post('/report/memberList', requestData).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getListFileAdmin (ankenId, reportType = null) {
    return new Promise((resolve, reject) => {
      const requestData = { ankenId }
      if (reportType !== null) {
        requestData.reportType = reportType
      }
      ApiService.post('/report/adminList', requestData).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  viewFileClient (ankenId, reportId) {
    return new Promise((resolve, reject) => {
      ApiService.post('/report/memberRefer', { ankenId, reportId }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  viewFileAdmin (ankenId, reportId) {
    return new Promise((resolve, reject) => {
      ApiService.post('/report/adminRefer', { ankenId, reportId }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  changeNameReport (ankenId, reportId, reportName) {
    return new Promise((resolve, reject) => {
      ApiService.post('/report/changeReportName', { ankenId, reportId, reportName }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteReport (ankenId, reportId) {
    return new Promise((resolve, reject) => {
      ApiService.post('/report/deleteReport', { ankenId, reportId }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  reUploadReport (ankenId, reportId, base64URI) {
    return new Promise((resolve, reject) => {
      ApiService.post('/report/reUploadReport', { ankenId, reportId, base64URI }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  uploadReport (ankenId, reportName, base64URI, reportType = 1) {
    return new Promise((resolve, reject) => {
      ApiService.post('/report/uploadReport', { ankenId, reportName, base64URI, reportType }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
